<label classs="ps-medium-r mr-small-t" [class.link-hover]="!disabled" [attr.for]="id">
  <div class="medium-type ps-large-t" [ngClass]="disabled ? 'grey-600-text' : 'nordic-blue-900-text'">
    <input
      class="is-vishidden"
      role="radio"
      [id]="id"
      type="radio"
      [attr.name]="inputName"
      [value]="value"
      [name]="value"
      [disabled]="disabled"
      [checked]="selected"
      (keyup.space)="radioChange.emit()"
      (keyup.enter)="radioChange.emit()"
      (click)="radioChange.emit()"
    />
    <span class="ms-xsmall-r rounded" aria-hidden="true">
      <fcom-icon
        name="{{ selected ? 'radiobutton-selected' : 'radiobutton-unselected' }}"
        class="ir-xsmall"
      ></fcom-icon>
    </span>
    <span>
      <span class="font-body-1 medium-type">
        {{ label }}
      </span>
    </span>
  </div>
</label>
